import { Loader2 } from 'lucide-react';
import { ProviderTab } from '../phone/tabs/ProviderTab';
import { usePhoneSettingsForm } from '../phone/PhoneSettingsContext';

/**
 * Settings → "Anbieter & Nummer" page. Renders the unified
 * provider-config + number-shop view via `ProviderTab`. We deliberately
 * skip `SectionFrame` here because the user wants a tighter, heading-
 * less layout — the menu already labels the section, no need to repeat
 * "Anbieter & Nummer" as a big H2 inside the same view.
 */
export function ProviderSection() {
  const { form, setForm, loading } = usePhoneSettingsForm();
  if (loading) {
    return (
      <div className="flex h-32 items-center justify-center text-muted-foreground">
        <Loader2 className="mr-2 h-4 w-4 animate-spin" /> Lade …
      </div>
    );
  }
  return <ProviderTab form={form} setForm={setForm} />;
}
